import axios from "axios";

/**
 * APIクライアント
 *
 * このファイルでaxiosの基本設定を行う
 *
 * @module utils/apiClient
 */

/**
 * APIクライアントの基本設定
 * @var {Object} opt
 * @property {String} baseURL APIのベースURL
 * @property {Int} timeout タイムアウトの時間(milisec)
 */
const opt = {
    // [TODO] 適切なCONFIG設定等用意する
    //   baseURL: process.env.VUE_APP_API_BASEURL,
    timeout: 300000,
};

// システムエラー発生時の遷移先
// [TODO] 適切なURLを設定する
// const ERR_URL = '/common/error'

const http = axios.create(opt);

// クリティカルなエラー(status=500)発生時時の共通処理
// システムエラー表示用のurlに遷移する
http.interceptors.response.use(
    (response) => {
        let callbackdata = {};
        callbackdata.status = response.status;
        callbackdata.data = {};
        callbackdata.data.response = response.data;
        return callbackdata;
    },
    (error) => {
        switch (error.response?.status) {
            case 400:
                // console.log("不正なリクエスト");
                break;
            case 404:
                // console.log("404 Not Found");
                break;
            case 422:
                // console.log("Validation Error");
                break;
            case 500:
                // console.log("Internal Server Error");
                break;
            default:
            // window.location.assign(ERR_URL)
            // console.log("Flash Error");
        }
        // return Promise.reject(error);
    }
);

export default http;
